import * as React from "react";

export type IconType =  "plus" | "menu1" | "menu" | "help" | "check-1" | "check" | "envelop" | "wallet" | "close" | "align" | "caret-right" | "caret-left" | "caret-down" | "facebook" | "twitter" | "instagram" | "eye" | "edit" | "love" | "upload" | "bell" | "profile" | "forward" ;

export interface IconProps {
    type: IconType;
    faType?: string;
    style?: React.CSSProperties;
    className?: string;
    onClick?: () => void;
    onMouseDown?: () => void;
    onMouseUp?: () => void;
}

export interface IconState {
}

export default class Icon extends React.Component<IconProps, IconState> {
  constructor(props: IconProps) {
    super(props);

    this.state = {
    };
  }

  public render() {
    return (
      <i onMouseDown={this.props.onMouseDown}
         onMouseUp={this.props.onMouseUp}
         onClick={this.props.onClick}
         className={`${this.props.faType ? "fa fa-" + this.props.faType : "icon-" + this.props.type} ${this.props.className || ""}`}
         style={this.props.style}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/icon.tsx